import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { CategoriesProvider, CategoryModel } from '../../providers/categories/categories';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Observer } from 'rxjs';

/**
 * Generated class for the CategoryNamePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'categoryName',
  pure: true
})
export class CategoryNamePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */

  constructor(private categoryService: CategoriesProvider, private translateService: TranslateService, private _ref: ChangeDetectorRef) { }

  storedCategory: CategoryModel;
  value = '';
  lastKey;
  async updateValue(key: string, obs: Observer<string>) {
    this.value = await this.transformCore(parseInt(key));
    this.lastKey = this.value;
    if (obs) obs.next(this.value);
    this._ref.markForCheck();
  }

  async transformCore(cid: number): Promise<string> {
    let category: CategoryModel;
    if (this.storedCategory && this.storedCategory.id === cid) {
      category = this.storedCategory;
    } else {
      let categories = await this.categoryService.getAllCategories();
      category = categories.find(x => x.id === cid);
      this.storedCategory = category;
    }

    let langKey = category.uniqueName;
    console.log(langKey);
    let newName = this.translateService.instant(langKey);
    if (newName === langKey) {
      newName = category.name;
    }
    this.value = newName;
    return newName;
  }

  async transform(cid: number, ...args): Promise<string> {
    let category: CategoryModel;
    if (this.storedCategory && this.storedCategory.id === cid) {
      category = this.storedCategory;
    } else {
      let categories = await this.categoryService.getAllCategories();
      category = categories.find(x => x.id === cid);
      this.storedCategory = category;
    }

    return (typeof category === "undefined") ? "" : category.uniqueName;
  }

  onTranslationChange;
  onLangChange;
  onDefaultLangChange;
  _dispose() {
    if (typeof this.onTranslationChange !== 'undefined') {
      this.onTranslationChange.unsubscribe();
      this.onTranslationChange = undefined;
    }
    if (typeof this.onLangChange !== 'undefined') {
      this.onLangChange.unsubscribe();
      this.onLangChange = undefined;
    }
    if (typeof this.onDefaultLangChange !== 'undefined') {
      this.onDefaultLangChange.unsubscribe();
      this.onDefaultLangChange = undefined;
    }
  }
  ngOnDestroy() {
    this._dispose();
  }
}



// WEBPACK FOOTER //
// /src/pipes/category-name/category-name.ts